// pdfExport.js
// Generic PDF export utility built on jsPDF + jspdf-autotable. Takes structured data
// (title, subtitle, meta lines, one or more table sections) and produces a clean vector
// PDF — real text, not a rasterized screenshot, so it stays crisp when pasted/zoomed
// into an architectural drawing set.
//
// Built for Load Schedule but deliberately generic — any future AV & Lighting tool that
// needs a "hand this to someone else as a PDF" export should call this with its own data
// shape rather than duplicating PDF-generation code per tool.

import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";

export function exportPdf({ title, subtitle, meta = [], sections = [], filename = "export.pdf" }) {
  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.getWidth();
  let y = 18;

  doc.setFontSize(16);
  doc.setFont(undefined, "bold");
  doc.text(title, 14, y);
  y += 8;

  if (subtitle) {
    doc.setFontSize(12);
    doc.setFont(undefined, "normal");
    doc.text(subtitle, 14, y);
    y += 6;
  }

  meta.forEach((line) => {
    doc.setFontSize(10);
    doc.setTextColor(100);
    doc.text(line, 14, y);
    y += 5;
  });
  doc.setTextColor(0);
  y += 4;

  sections.forEach((section) => {
    if (y > 260) {
      doc.addPage();
      y = 18;
    }

    doc.setFontSize(12);
    doc.setFont(undefined, "bold");
    doc.text(section.heading, 14, y);
    y += 4;

    autoTable(doc, {
      startY: y,
      head: [section.columns],
      body: section.rows,
      styles: { fontSize: 9 },
      headStyles: { fillColor: [23, 35, 61] },
      margin: { left: 14, right: 14 },
    });
    y = doc.lastAutoTable.finalY + 6;

    if (section.footer) {
      doc.setFontSize(10);
      doc.setFont(undefined, "bold");
      const lines = doc.splitTextToSize(section.footer, pageWidth - 28);
      doc.text(lines, 14, y);
      y += lines.length * 5 + 8;
    }
  });

  doc.save(filename);
}
